/* bfc.js — Best Friend Club. Vanilla only. Three jobs: the header's Login + primary-CTA pills, the cart icon that hides when the cart is empty
   (the approved mock shows no cart in the header), and the per day / month / kg toggle on the price cards. */
(function () {
  /* header pills: the skin section renders <template id="bfc-header-pills">; desktop gets both, mobile gets the orange pill only */
  var tpl = document.getElementById('bfc-header-pills');
  if (tpl) {
    var right = document.querySelector('.m-header__right');
    if (right && !right.querySelector('.bfc-hd-cta')) right.appendChild(tpl.content.cloneNode(true));
    /* mobile bar: the orange pill sits right after the logo, the account icon joins the right group next to the burger */
    var bar = document.querySelector('.m-header__mobile');
    var mob = document.querySelector('.m-header__mobile-right');
    if (bar && !bar.querySelector('.bfc-hd-cta')) {
      var frag = tpl.content.cloneNode(true);
      var login = frag.querySelector('.bfc-hd-login');
      if (login) login.parentNode.removeChild(login);
      /* Nik 2026-09-05: both on the right — the CTA pill, then the account icon, then the burger */
      if (mob) mob.appendChild(frag); else bar.appendChild(frag);
    }
  }

  /* cart link: hidden while the cart is empty */
  function cartState() {
    var counts = document.querySelectorAll('.m-cart-count, m-cart-count, [data-cart-count]');
    var n = 0;
    Array.prototype.forEach.call(counts, function (c) { var v = parseInt((c.textContent || '').trim(), 10); if (!isNaN(v)) n = Math.max(n, v); });
    document.documentElement.classList.toggle('bfc-cart-empty', n === 0);
  }
  cartState();
  var mo = new MutationObserver(cartState);
  Array.prototype.forEach.call(document.querySelectorAll('.m-cart-count, m-cart-count'), function (c) { mo.observe(c, { childList: true, characterData: true, subtree: true }); });
  document.addEventListener('cart:refresh', function () { setTimeout(cartState, 400); });

  /* price toggle: each card carries data-day / data-month / data-kg; the unit follows the mode */
  var UNIT = { day: '/ day', month: '/ month', kg: '/ kg' };
  Array.prototype.forEach.call(document.querySelectorAll('[data-bfc-prices]'), function (root) {
    var buttons = root.querySelectorAll('.bfc-toggle button');
    function setMode(mode) {
      Array.prototype.forEach.call(buttons, function (b) { b.classList.toggle('is-on', b.getAttribute('data-mode') === mode); b.setAttribute('aria-pressed', b.getAttribute('data-mode') === mode ? 'true' : 'false'); });
      Array.prototype.forEach.call(root.querySelectorAll('.bfc-pcard'), function (card) {
        var v = card.getAttribute('data-' + mode);
        var el = card.querySelector('.bfc-pcard__price');
        if (el && v) { el.firstChild.textContent = v + ' '; el.querySelector('small').textContent = UNIT[mode]; }
      });
    }
    Array.prototype.forEach.call(buttons, function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-mode')); }); });
  });
})();

/* ---- motion: reveals (IO + off-screen-above sweep, once) and the count-up on the price toggle ---- */
(function () {
  var doc = document.documentElement;
  doc.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = Array.prototype.slice.call(document.querySelectorAll('.bfc-r, section[class^="bfc-"], .bfc-checks, .bfc-compare__row, .bfc-pcard'));
  function show(el) { el.classList.add('is-in'); }
  if (reduce || !('IntersectionObserver' in window)) { items.forEach(show); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.top < 0) { show(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  items.forEach(function (el) { io.observe(el); });
  var ticking = false;
  function sweep() {
    ticking = false; var h = window.innerHeight;
    items.forEach(function (el) { if (el.classList.contains('is-in')) return; var r = el.getBoundingClientRect(); if (r.top < h * 0.92 || r.top < 0) { show(el); io.unobserve(el); } });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
  setTimeout(sweep, 80);
})();
(function () {
  /* count-up: the price toggle above swaps the text instantly; this replays it as a 450ms count from the old figure */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  Array.prototype.forEach.call(document.querySelectorAll('[data-bfc-prices]'), function (root) {
    var prev = {};
    Array.prototype.forEach.call(root.querySelectorAll('.bfc-pcard'), function (card, i) { prev[i] = parseFloat((card.getAttribute('data-day') || '').replace(/[^0-9.]/g, '')) || 0; });
    Array.prototype.forEach.call(root.querySelectorAll('.bfc-toggle button'), function (b) {
      b.addEventListener('click', function () {
        var mode = b.getAttribute('data-mode');
        Array.prototype.forEach.call(root.querySelectorAll('.bfc-pcard'), function (card, i) {
          var raw = card.getAttribute('data-' + mode) || ''; var target = parseFloat(raw.replace(/[^0-9.]/g, '')); if (isNaN(target)) return;
          var sym = raw.replace(/[0-9.,\s]/g, '') || '£'; var from = prev[i] || 0; prev[i] = target;
          var el = card.querySelector('.bfc-pcard__price'); var t0 = null;
          el.classList.add('is-ticking');
          function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 450); var e = 1 - Math.pow(1 - p, 3); el.firstChild.textContent = sym + (from + (target - from) * e).toFixed(2) + ' '; if (p < 1) requestAnimationFrame(step); else el.classList.remove('is-ticking'); }
          requestAnimationFrame(step);
        });
      });
    });
  });
})();
